export const SET_RESPONSE = 'SET_RESPONSE';
export const SET_FILTER_RAYON = 'SET_FILTER_RAYON';
export const SET_CONCURRENTS = 'SET_CONCURRENTS';
export const SET_NBRE_CONCURRENTS = 'SET_NBRE_CONCURRENTS';
